import { render } from "./Footer.vue?vue&type=template&id=4de744e4"
const script = {}
script.render = render

export default script